module.exports = "/_next/static/images/442cf187002ff92f4484f9c75c03d129-cards.svg";